import Avatar, { AvatarProps } from '@/common/base/avatar';
import useUserStore from '@/stores/userStore';

export default function UserAvatar(props: Omit<AvatarProps, 'name'>) {
  const displayName = useUserStore(s => s.displayName);
  const initial = displayName.charAt(0).toUpperCase() || '?';
  return <Avatar {...props} name={initial} />;
}
